import React from 'react';
import './style.css';
import {config} from 'config';
import moment from 'moment';
import '../../static/fonts/fontawesome/style.css';

class SiteFooter extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="footerWrapper">
          <p className="floatLeft">{ config.siteTitle } <i className="fa fa-copyright" aria-hidden="true"></i> { moment().format('YYYY') }</p>
          <p className="floatRight">Built with gatsby.js, hosted on Github Pages.</p> 
        </div>
      </footer>
    );
  }
}

SiteFooter.propTypes = {
  location: React.PropTypes.object,
};

export default SiteFooter;




// WEBPACK FOOTER //
// ../components/SiteFooter/index.jsx